/**
 * Mobile diagram toggle for the #product "what we do" section.
 *
 * A segmented control (Without Stance / With Stance) that swaps which of the
 * two ecosystem diagrams is shown by flipping `data-active` on `.layer-diagrams`
 * (the CSS reads that to reveal one panel). Mobile-only in effect — on lg+ the
 * toggle is hidden and both diagrams render side by side, so this is inert.
 */
document.querySelectorAll('.layer-toggle').forEach((toggle) => {
  const diagrams = toggle.parentElement?.querySelector('.layer-diagrams');
  if (!diagrams) return;

  toggle.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-layer-target]');
    if (!btn) return;

    diagrams.dataset.active = btn.dataset.layerTarget;

    toggle.querySelectorAll('[data-layer-target]').forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  });
});
